import { defineComponent as _defineComponent } from 'vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellLogApplication: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'TableCellLogApplication' };

import { computed } from 'vue';
import type { OutputLogEvent } from '@models';
import zephyrDashboardLogo from '@assets/images/zephyr-dashboard-logo.png';
import littleArmsLauncherLogo from '@assets/images/little-arms-launcher-logo.png';
/**
 * `TableCellLogApplication` component properties.
 */
export interface Props {
  item: OutputLogEvent;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: OutputLogEvent;
};



const application = computed(() => props.item.application);

const webVersion = computed(() => props.item.webVersion);

const apiVersion = computed(() => props.item.apiVersion);

const launcherVersion = computed(() => props.item.launcherVersion);

const simulatorVersion = computed(() => props.item.simulatorVersion);

const launcherTooltip = computed(() => {
  return application.value === 'Little Arms Launcher' ? `\nLAUNCHER | ${launcherVersion.value} SIMULATOR | ${simulatorVersion.value}` : '';
});

const simulatorTooltip = computed(() => {
  return simulatorVersion.value ? `\nZEPHYR | ${simulatorVersion.value}` : '';
});

const webTooltip = computed(() => {
  return webVersion.value ? `\nWEB | ${webVersion.value}` : '';
});

const tooltip = computed(() => {
  return `API | ${apiVersion.value} ${webTooltip.value} ${launcherTooltip.value} ${simulatorTooltip.value}`;
});


return { __sfc: true,props, application, webVersion, apiVersion, launcherVersion, simulatorVersion, launcherTooltip, simulatorTooltip, webTooltip, tooltip, zephyrDashboardLogo, littleArmsLauncherLogo }
}

})